import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/components/layout/Home'
import HomePage from '@/views/HomePage'
import Login from '@/views/Login/Login'

import Dict from '@/views/System/Dict'//系统设置 - 字典管理
import Menu from '@/views/System/Menu'//系统设置 - 菜单管理
import Role from '@/views/System/Role'//系统设置 - 角色管理
import User from '@/views/System/User'//系统设置 - 用户管理
import Office from '@/views/System/Office'//系统设置 - 部门管理
import Feedback from '@/views/Feedback/Feedback' //廉政评价管理 - 用户反馈管理

import Feedbackform from '@/views/h5'

Vue.use(Router);
// 路由

export default new Router({
  routes: [
    {
      path: '/',
      components:{
        app:Home
      },
      children:[
        {
          path: 'HomePage',
          name: 'HomePage',
          components:{
            pages:HomePage
          },
        },
        {
          path: 'Dict',
          name: 'Dict',
          components:{
            pages:Dict
          },
        },
        {
          path: 'Menu',
          name: 'Menu',
          components:{
            pages:Menu
          },
        },
        {
          path: 'Role',
          name: 'Role',
          components:{
            pages:Role
          },
        },
        {
          path: 'User',
          name: 'User',
          components:{
            pages:User
          },
        },
        {
          path: 'Office',
          name: 'Office',
          components: {
            pages:Office
          }
        },
        {
          path: 'Feedback',
          name: 'Feedback',
          components: {
            pages:Feedback
          }
        },
        { path: '/', redirect: 'HomePage' },

      ]
    },
    {
      path: '/Login',
      name: 'Login',
      components:{
        app:Login
      },
    },
    {
      path: '/Feedbackform',
      name: 'Feedbackform',
      components: {
        app:Feedbackform
      }
    }
  ]
})
